import React, { useEffect, useState } from "react";

interface MicrolinkData {
  title: string;
  description: string;
  url: string;
  image?: {
    url: string;
  };
  logo?: {
    url: string;
  };
}

interface LinkPreviewProps {
  url: string;
}

const fetchMicrolinkData = async (
  url: string
): Promise<MicrolinkData | null> => {
  try {
    const response = await fetch(
      `https://api.microlink.io/?url=${encodeURIComponent(url)}`
    );
    const result = await response.json();
    return result?.data || null;
  } catch (error) {
    console.error("Microlink fetch error:", error);
    return null;
  }
};

const LinkPreview: React.FC<LinkPreviewProps> = ({ url }) => {
  const [meta, setMeta] = useState<MicrolinkData | null>(null);

  useEffect(() => {
    fetchMicrolinkData(url).then(setMeta);
  }, [url]);

  if (!meta) return <p className="text-sm text-gray-500">Loading preview...</p>;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="flex gap-2 items-center border p-2 rounded hover:shadow max-w-[250px]"
    >
      <img
        src={meta.image?.url || meta.logo?.url}
        alt="preview"
        className="w-12 h-12 object-cover rounded"
        style={{ width: "200px", height: "170px", objectFit: "cover" }}
      />
      {/* <div>
        <p className="font-bold text-sm truncate">{meta.title}</p>
        <p className="text-xs text-gray-600 truncate">{meta.description}</p>
      </div> */}
    </a>
  );
};

export default LinkPreview;
